import type { Area } from 'react-easy-crop';
import type {
  CourseTypes,
  DurationTypes,
  ModalityTypes,
} from '@/models/catalog/course';

export enum CourseSourceTypes {
  CatalogGalena = 'internal_catalog',
  ManualInsertion = 'manual_insertion',
}

export type EmbeddedCourse = {
  institution_name?: string;
  institution_id: number;
  name: string;
  id: string;
  modality: ModalityTypes;
  course_type: CourseTypes;
  source: CourseSourceTypes;
  external_course_url?: string | null;
  external_course_id?: string | null;
  external_offer_id?: string | null;
  external_institution_logo_url?: string | null;
  external_institution_background_color?: string | null;
  duration?: number;
  duration_type?: DurationTypes;
  about?: string;
};

export enum ResourceTypesLabels {
  Course = 'Curso',
  Book = 'Livro',
  Video = 'Vídeo',
  Podcast = 'Podcast',
  EventOrLecture = 'Evento ou Palestra',
  Document = 'Documento',
  Others = 'Outros',
}

export enum ResourceTypes {
  Course = 'course',
  Book = 'book',
  Podcast = 'podcast',
  Video = 'video',
  Document = 'document',
  EventOrLecture = 'event_or_lecture',
  Others = 'others',
}

export interface ResourceType {
  label: ResourceTypesLabels;
  value: ResourceTypes;
}

export type ExternalResourceCoverImage = {
  blob?: string | null;
  url?: string | null;
  cropArea?: Area;
  previewUrl?: string | null;
};

export interface ExternalResource {
  id?: string;
  name: string;
  description?: string;
  category: ResourceTypesLabels;
  url?: string;
  cover_image_url?: string | null; // show
  cover_image?: ExternalResourceCoverImage | null; // edit
}
